import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../Contexts/AuthContext";
import ht from "../../Images/T_logo_rgb_n.svg";
import iskon from "../../Images/logo-iskon.svg";
import "../../Style/Login.css";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Footer from "../Common/Footer";

const ForgotPassword = () => {
  const { t: translator } = useTranslation();
  const { forgotPassword, validationMsg, setValidationMsg } =
    useContext(AuthContext);

  useEffect(() => {
    document.body.id =
      window.REACT_APP_COLOR != "#eb7203" ? "login" : "login-iskon";
  }, []);

  const [username, setUsername] = useState("");

  const handleChange = (e) => {
    const { value } = e.target;
    setValidationMsg("");
    setUsername(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!username) {
      setValidationMsg("ForgotPassword-ValidationMsg-Username");
      return false;
    }
    forgotPassword(username)
      .then((res) =>
        res.status == "200"
          ? setValidationMsg("ForgotPassword-ResetPassword")
          : setValidationMsg("ForgotPassword-InvalidUsername"),
      )
      .catch((err) => setValidationMsg("ForgotPassword-InvalidUsername"));
  };

  return (
    <div>
      <nav className="navbar navbar-expand-lg brand-color p-0">
        <span className="navbar-brand pl-4">
          <img
            src={window.REACT_APP_VENDOR === "ht" ? ht : ht}
            alt="logo"
            id={`logo-login-${window.REACT_APP_VENDOR}`}
          />
        </span>
      </nav>
      <div id="login-body-wrapper">
        <div className="col-lg-4" id={`login-box-${window.REACT_APP_VENDOR}`}>
          <h5 className="text-center text-uppercase teleServiceName">
            <strong>{translator("ForgotPassword-AndroidCashRegister")}</strong>
          </h5>
          <h1 className="text-center py-4 teleh1">
            {translator("ForgotPassword-ForgotPassword")}
          </h1>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                className="form-control"
                id="email"
                name="email"
                placeholder="Username"
                onChange={handleChange}
              />
            </div>
            <div className="text-center text-danger mb-2">
              <span>{translator(validationMsg)}</span>
            </div>
            <button type="submit" className="btn btn-primary w-100">
              {translator("Btn-Send")}
            </button>
          </form>
          <div className="mt-4">
            <Link to="/" className="teleLink">
              {translator("ForgotPassword-Home")}
            </Link>
            <a
              className="teleLink float-right"
              href="https://www.hrvatskitelekom.hr/poslovni/podrska-poslovni/ict"
              target="_blank"
            >
              {translator("ForgotPassword-Help")}
            </a>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ForgotPassword;
